<template>
  <div :style="{'background-color':'#F7F7F7'}">
<!--  <div :style="{'min-height':clientHeight+'px','background-color':'#F7F7F7','padding-bottom':'50px'}" id="outermost">-->
<!--    <van-nav-bar title="医院废水监控平台" id="topbar"/>-->

    <div class="content">
      <!-- 状态卡片 -->
      <div class="status-cards">
        <div class="status-card">
          <div class="status-title" style="font-size: 14px">在线设备</div>
          <div class="status-value flip-number" :key="'online-' + updateCounter">4</div>
        </div>
        <div class="status-card">
          <div class="status-title" style="font-size: 14px">累计流量</div>
          <div class="status-value flip-number" :key="'flow-' + updateCounter">
            {{cardInfo.cumulativeFlow}}
            <span class="status-title" style="font-size: 13px">m³</span>
          </div>
        </div>
        <div class="status-card" :class="{ 'danger': cardInfo.pendingAlarm > 0 }">
          <div class="status-title" style="font-size: 14px">待处理告警</div>
          <div class="status-value flip-number" :key="'alarm-' + updateCounter">{{ cardInfo.pendingAlarm }}</div>
        </div>
      </div>

      <!-- 实时监测数据 -->
      <div class="monitor-section">
        <div class="section-title">实时监测数据</div>
        <div class="status-overview">
          <div class="status-card" v-for="(item, index) in cardInfo.monitorData" :key="index" :class="item.class">
            <div class="status-icon">
              <van-icon :color="item.class === 'status-danger' ? '#FF4D4F' : '#52C41A' " name="clock-o" size="24" />
            </div>
            <div class="status-info">
              <div class="status-label">{{ item.label }}</div>
              <div class="status-value flip-number" :key="'monitor-' + index + '-' + updateCounter">
                {{ item.value }}
              </div>
              <div class="status-unit">{{ item.unit }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 最近报警记录 -->
      <div class="monitor-section">
        <div class="section-title">待处理告警</div>
        <div class="scrollable-list">
          <div v-if="alarmList.length === 0 && finished" class="empty-alarm">
            <div class="empty-icon">
              <van-icon name="success" size="48" color="#52C41A" />
            </div>
            <div class="empty-text">暂无待处理告警</div>
            <div class="empty-subtext">系统运行正常</div>
          </div>
          <div v-else>
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
              <van-list v-model="loading" :finished="finished"
                :finished-text="alarmList.length === 0 ? '' :'没有更多了'"
                @load="onLoad" :immediate-check="false" class="alarm-list">

                <div class="alarm-item" v-for="(item, index) in alarmList" :key="index">
                  <div class="alarm-icon">
                    <van-icon name="warning" size="24" color="#FF4D4F" />
                  </div>
                  <div class="alarm-content">
                    <div class="alarm-header">
                      <h4 class="alarm-title">{{ item.alarmName }}</h4>
                      <span class="alarm-time">{{ getTimeRange(item.alarmStartTime,item.alarmEndTime) }}</span>
                    </div>
                    <p class="alarm-desc">监测值：{{item.minValue && item.maxValue ? item.minValue + "~" + item.maxValue : " - - " }},阈值区间：{{item.rangeValue}}</p>
                  </div>
                  <div class="alarm-action">
                    <van-button type="primary" size="small" @click="handleAlarm(item)" class="action-button">
                      处理告警
                    </van-button>
                  </div>
                </div>
              </van-list>
            </van-pull-refresh>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部导航组件 -->
    <tabular :active="0"/>

    <!-- 处理告警对话框 -->
    <van-dialog
      v-model="dialogVisible"
      title="处理告警"
      width="80%"
      :show-confirm-button="false"
    >
      <van-form style="padding: 10px 10px 0" label-width="65px">
        <van-field
          v-model="formData.userName"
          label="处理人" colon required
          placeholder="请输入处理人姓名"
          style="line-height: 2"
          class="custom-field"
        />
        <van-field
          v-model="formData.measures"
          label="描述" colon
          type="textarea"
          style="line-height: 2"
          placeholder="请输入处理措施..."
          rows="2"
        />
        <div style="margin: 16px; display: flex; justify-content: center; gap: 10px">
          <van-button class="confirm-btn" @click="submitForm">提交处理</van-button>
          <van-button class="cancel-btn" @click="dialogVisible = false">取消</van-button>
        </div>
      </van-form>
    </van-dialog>
  </div>
</template>
<script>
import $ from '@/fly'
import Tabular from '@/components/tabbar.vue';
import { Dialog, Toast } from 'vant';
import _ from 'lodash';

export default {
  name: 'homepage',
  components: { Tabular },
  data () {
    return {
      clientHeight: window.screen.height,
      timer:null,
      updateCounter: 0, // 用于触发数字翻转效果
      refreshing: false,  // 下拉刷新状态
      finished: false,  // 是否加载完成
      loading: false,  //是否加载状态
      cardInfo: {
        cumulativeFlow: 0,
        pendingAlarm: 0,
        monitorData: [
          {
            value: 0,
            label: '温度',
            class: 'status-normal',
            unit: '℃'
          },
          {
            value: 0,
            label: '瞬时流量',
            class: 'status-normal',
            unit: 'L/S'
          },
          {
            value: 0,
            label: '余氯',
            class: 'status-normal',
            unit: 'mg/L (达标: 2 ~ 8)'
          },
          {
            value: 0,
            label: 'pH',
            class: 'status-normal',
            unit: 'pH (达标: 6 ~ 9)'
          }
        ]
      },
      alarmList: [],
      // 分页相关
      pageNum: 1,
      pageSize: 10,
      // 表单相关
      dialogVisible: false,
      formData: {
        userName: '',
        measures: ''
      },
    }
  },
  methods: {
    //初始化数据
    initHomeData () {
      this.getHomeCardData()
      this.getHomeListData()
      this.timer = setInterval(() => {
        this.getHomeCardData()
      }, 5000);
    },
    // 获取实时监控数据
    getHomeCardData () {
      $.get('mobile/homepage/getCardData').then(res=>{
        const obj = res.data;
        this.cardInfo.pendingAlarm = obj.pendingAlarm || 0
        this.cardInfo.cumulativeFlow = obj.cumulativeFlow || 0
        this.cardInfo.monitorData = [
          {
            value: obj.waterTemperature || 0,
            label: '温度',
            class: 'status-normal',
            unit: '℃'
          },
          {
            value: obj.flow || 0,
            label: '瞬时流量',
            class: 'status-normal',
            unit: 'L/S'
          },
          {
            value: obj.chloride || 0,
            label: '余氯',
            class: this.whetherRange(obj.chloride,2,8) ? 'status-normal' : 'status-danger',
            unit: 'mg/L (达标: 2 ~ 8)'
          },
          {
            value: obj.ph || 0,
            label: 'pH',
            class: this.whetherRange(obj.ph,6,9) ? 'status-normal' : 'status-danger',
            unit: 'pH (达标: 6 ~ 9)'
          }
        ]
        // 更新计数器以触发数字翻转效果
        this.updateCounter++
      })
    },
    // 判断是否在范围
    whetherRange (value,start,end) {
      if (value !== null && value !== undefined && !isNaN(value)) {
        return value >= start && value <= end;
      }
      return false
    },
    // 获取待处理告警数据
    getHomeListData () {
      this.loading = true;
      $.get('mobile/homepage/getListData',{pageNum:this.pageNum,pageSize:this.pageSize,status:'0'}).then(res=>{
        const list = res.data || [];

        if (list.length === 0) {
          this.finished = true;
        } else {

          if (this.pageNum === 1) {
            this.alarmList = [...list];
          } else {
            this.alarmList = [...this.alarmList, ...list];
          }

          this.finished = list.length < this.pageSize;
        }
      }).catch(() => {
        this.finished = true
      }).finally(() => {
        this.loading = false
        this.refreshing = false

        if (!this.finished) {
          this.pageNum++;
        }
      })
    },
    // 触底加载
    onLoad () {
      if (!this.finished) {
        this.getHomeListData()
      }
    },
    // 下拉数据列表刷新
    onRefresh() {
      this.pageNum = 1
      this.finished = false;
      this.alarmList = []
      this.getHomeListData();
    },
    // 重置数据，帮助垃圾回收
    clearHomeData () {
      this.refreshing = false
      this.finished = false
      this.loading = false
      this.cardInfo = {
        cumulativeFlow: 0,
        pendingAlarm: 0,
        monitorData: [
          {
            value: 0,
            label: '温度',
            class: 'status-normal',
            unit: '℃'
          },
          {
            value: 0,
            label: '瞬时流量',
            class: 'status-normal',
            unit: 'L/S'
          },
          {
            value: 0,
            label: '余氯',
            class: 'status-normal',
            unit: 'mg/L (达标: 2 ~ 8)'
          },
          {
            value: 0,
            label: 'pH',
            class: 'status-normal',
            unit: 'pH (达标: 6 ~ 9)'
          }
        ]
      }
      this.alarmList = []
      this.dialogVisible = false
      this.pageNum = 1
      this.pageSize = 5
      this.formData = {
        userName: '',
        measures: ''
      }
    },
    // 获取告警时间范围
    getTimeRange (startTime,endTime) {
      if (startTime !== null && startTime !== undefined && endTime !== null && endTime !== undefined) {
        return startTime.slice(5, 16) + ' ~ ' + endTime.slice(5, 16)
      }
      return ''
    },
    // 处理报警
    handleAlarm (item) {
      this.formData = _.cloneDeep(item)
      this.dialogVisible = true;
    },
    // 提交表单
    submitForm () {
      if (!this.formData.userName) {
        Dialog.alert({ title: '提示', message: '请输入处理人姓名' });
        return;
      }
      $.post('mobile/homepage/dealAlarm',this.formData, { contentType: 'application/json' }).then(()=>{
        this.finished = false;
        this.alarmList = []
        this.pageNum = 1
        this.getHomeListData();
        Toast.success('处理完成！');
      }).finally(() => {
        this.dialogVisible = false;
      })
    }
  },
  mounted () {
    this.initHomeData()
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    this.clearHomeData();
  }
}
</script>

<style lang="less" scoped>

.content {
  height: calc(100vh - 50px);
}

.status-cards {
  padding: 20px 10px 30px;
  display: flex;
  justify-content: space-between;

  gap: 12px;

  .status-card {
    flex: 1;
    background: linear-gradient(135deg, #1B75F6 0%, #4A90E2 100%);
    border-radius: 25px;
    padding: 30px 0;
    text-align: center;
    color: white;
    box-shadow: 0 2px 8px rgba(27, 117, 246, 0.3);
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(27, 117, 246, 0.4);
    }

    &.danger {
      background: linear-gradient(135deg, #FF4D4F 0%, #FF7875 100%);
      box-shadow: 0 2px 8px rgba(255, 77, 79, 0.3);
      animation: breathe-danger 2s infinite ease-in-out;

      &:hover {
        box-shadow: 0 4px 12px rgba(255, 77, 79, 0.4);
      }
    }

    .status-title {
      margin-bottom: 10px;
      opacity: 0.9;
    }

    .status-value {
        font-size: 40px;
        font-weight: bold;
      }

      .flip-number {
        animation: flipNumber 0.5s ease-in-out;
      }

      @keyframes flipNumber {
        0% {
          transform: rotateX(0deg);
          opacity: 1;
        }
        50% {
          transform: rotateX(90deg);
          opacity: 0;
        }
        100% {
          transform: rotateX(0deg);
          opacity: 1;
        }
      }
  }
}

.monitor-section {
  background: white;
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);

  .section-title {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 20px;
    color: #333;
  }
}

.status-overview {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 20px;

  .status-card {
    background: rgb(249, 250, 250);
    border-radius: 20px;
    padding: 20px;
    display: flex;
    align-items: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    }

    &.status-danger {
      border-left: 4px solid #FF4D4F;
      animation: breathe-danger 2s infinite ease-in-out;
    }

    &.status-normal {
      border-left: 4px solid #52C41A;
      animation: breathe-normal 2s infinite ease-in-out;
    }

    @keyframes breathe-danger {
      0% {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
      }
      50% {
        box-shadow: 0 0 20px rgba(255, 77, 79, 0.6);
      }
      100% {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
      }
    }

    @keyframes breathe-normal {
      0% {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
      }
      50% {
        box-shadow: 0 0 20px rgba(82, 196, 26, 0.6);
      }
      100% {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
      }
    }

    .status-icon {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      background: #F0F2F5;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 15px;
    }

    .status-info {
      flex: 1;

      .status-label {
        font-size: 27px;
        color: #666;
        margin-bottom: 4px;
      }

      .status-value {
        font-size: 40px;
        font-weight: bold;
        color: #333;
        margin-bottom: 4px;
      }

      .flip-number {
        animation: flipNumber 0.5s ease-in-out;
      }

      @keyframes flipNumber {
        0% {
          transform: rotateX(0deg);
          opacity: 1;
        }
        50% {
          transform: rotateX(90deg);
          opacity: 0;
        }
        100% {
          transform: rotateX(0deg);
          opacity: 1;
        }
      }

      .status-unit {
        font-size: 25px
      }
    }
  }
}

.scrollable-list {
  padding-top: 3px;
  height: calc(43vh);
  overflow-y: auto;
  border-radius: 8px;

  /* 隐藏滚动条但保留滚动功能 */
  &::-webkit-scrollbar {
    width: 0;
  }

  -ms-overflow-style: none;
  scrollbar-width: none;

  .van-pull-refresh {
    height: 100%;
  }
}

.van-list {
  min-height: 100%;
}

.alarm-list {
  padding-bottom: 10px;
  min-height: 20vh;

  .alarm-item {
    display: flex;
    align-items: flex-start;
    background: #f6f6f6;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 16px;
    border: 1px solid #e6e6e6;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;

    &:last-child {
      margin-bottom: 0;
    }

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
    }

    .alarm-icon {
      margin-right: 16px;
      margin-top: 2px;
      flex-shrink: 0;
    }

    .alarm-content {
      flex: 1;

      .alarm-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 8px;

        .alarm-title {
          font-size: 27px;
          color: #FF4D4F;
          margin: 0;
          line-height: 1.4;
        }

        .alarm-time {
          font-size: 22px;
          color: #686868;
          white-space: nowrap;
          margin-right: -120px;
        }
      }

      .alarm-desc {
        font-size: 25px;
        color: #222121;
        line-height: 1.5;
        margin: 0;
      }
    }

    .alarm-action {
      flex-shrink: 0;
      margin-top: 45px;

      .action-button {
        font-size: 22px;
        border-radius: 15px;
        background: linear-gradient(135deg, #1B75F6 0%, #4A90E2 100%);
        border: none;
        box-shadow: 0 2px 4px rgba(27, 117, 246, 0.3);
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 8px rgba(27, 117, 246, 0.4);
        }
      }
    }
  }
}

.cancel-btn {
  width: 50%;
  color: white;
  background: #5c6064;
  border-radius: 20px;
}
.confirm-btn {
  width: 50%;
  color: white;
  border-radius: 20px;
  background: #34a853;
}

.empty-alarm {
  border-top: #a3a1a1 1px solid;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;

  .empty-icon {
    margin-bottom: 20px;
  }

  .empty-text {
    font-size: 30px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
  }

  .empty-subtext {
    font-size: 25px;
    color: #999;
  }
}

/deep/.van-cell__value {
  padding: 0 5px;
  border: 1px rgb(188, 188, 188) solid !important;
}
</style>
